export default function Lock() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.25" height="23" viewBox="0 0 17.25 23">
      <path id="padlock" d="M18.094,8.625h-.719V5.75a5.75,5.75,0,0,0-11.5,0V8.625H5.156A2.159,2.159,0,0,0,3,10.781V20.844A2.159,2.159,0,0,0,5.156,23H18.094a2.159,2.159,0,0,0,2.156-2.156V10.781A2.159,2.159,0,0,0,18.094,8.625ZM7.792,5.75a3.833,3.833,0,1,1,7.667,0V8.625H7.792Zm4.792,10.275v2.183a.958.958,0,1,1-1.917,0V16.025a1.917,1.917,0,1,1,1.917,0Z" transform="translate(-3)" />
    </svg>

  );
}
